if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');

        /** Auto-rotation settings */
        this.autoRotate = this.dataset.autoRotate === 'true';
        this.rotationSpeed = parseInt(this.dataset.rotationSpeed) || 8000;
        this.rotationInterval = null;
        this.isPaused = false;

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((item) => {
          item.querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, item.dataset.target, false));
        });

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }

        /** START AUTO ROTATION */
        this.initAutoRotation();
      }

      /* --------------------------------------------------------------
        ✔️ Detect if search modal is open
      -------------------------------------------------------------- */
      isSearchOpen() {
        const details = document.querySelector('details-modal.header__search details');
        return details && details.hasAttribute('open');
      }

      /* --------------------------------------------------------------
        ▶️ Auto Rotation
      -------------------------------------------------------------- */
      initAutoRotation() {
        if (!this.autoRotate) return;

        const slides = this.elements.viewer?.querySelectorAll('[data-media-id]');
        if (!slides || slides.length <= 1) return;

        this.startRotation();

        // Pause on hover
        this.addEventListener('mouseenter', () => this.pauseRotation());
        this.addEventListener('mouseleave', () => {
          if (!this.isSearchOpen()) this.startRotation();
        });

        // Pause on manual click
        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((thumb) => {
            thumb.addEventListener('click', () => {
              this.pauseRotation();
              setTimeout(() => {
                if (!this.isPaused && !this.isSearchOpen()) {
                  this.startRotation();
                }
              }, this.rotationSpeed * 2);
            });
          });
        }

        // Pause when page tab is hidden
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.pauseRotation();
          else if (!this.isPaused && !this.isSearchOpen()) this.startRotation();
        });

        // Pause when search drawer is opened
        const searchDetails = document.querySelector('details-modal.header__search details');
        if (searchDetails) {
          searchDetails.addEventListener('toggle', () => {
            if (searchDetails.open) {
              this.pauseRotation();   // STOP auto-slide
            } else {
              this.startRotation();   // RESUME
            }
          });
        }
      }

      startRotation() {
        if (this.rotationInterval) clearInterval(this.rotationInterval);
        if (this.isSearchOpen()) return; // ❗ Prevent sliding when search open

        this.rotationInterval = setInterval(() => {
          if (!this.isPaused && !this.isSearchOpen()) {
            this.rotateToNextSlide();
          }
        }, this.rotationSpeed);

        console.log('▶️ Auto-rotation running');
      }

      pauseRotation() {
        if (this.rotationInterval) clearInterval(this.rotationInterval);
        console.log('⏸ Auto-rotation paused');
      }

      rotateToNextSlide() {
        const nextBtn = this.elements.viewer?.querySelector('.slider-button--next');
        if (nextBtn && !this.isSearchOpen()) {
          nextBtn.click();  // DOES NOT CLOSE SEARCH ANYMORE
          console.log('🔄 Next slide');
        }
      }

      toggleRotation() {
        this.isPaused = !this.isPaused;
        this.isPaused ? this.pauseRotation() : this.startRotation();
      }

      /* --------------------------------------------------------------
        Slides / Thumbnails
      -------------------------------------------------------------- */
      onSlideChanged(event) {
        const thumb = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumb);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]')
          .forEach((el) => el.classList.remove('is-active'));

        activeMedia.classList.add('is-active');

        if (prepend) {
          if (activeMedia.parentElement.firstChild !== activeMedia) {
            activeMedia.parentElement.prepend(activeMedia);
          }
        }

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumb = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumb);
      }

      setActiveThumbnail(thumb) {
        if (!thumb) return;

        this.elements.thumbnails.querySelectorAll('button')
          .forEach((btn) => btn.removeAttribute('aria-current'));

        thumb.querySelector('button').setAttribute('aria-current', true);
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferred = activeItem.querySelector('.deferred-media');
        if (deferred) deferred.loadContent(false);
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute('role', 'presentation')
        );
      }

      disconnectedCallback() {
        if (this.rotationInterval) clearInterval(this.rotationInterval);
      }
    }
  );
}
